import React from 'react';
import classnames from 'clsx';

import styles from './styles.module.less';
import responsiveStyles from '../responsive-layout/styles.module.less';

/**
 * @typedef {object} FlexRowProps
 * @property {React.ReactNode} children - The children to render in the row.
 * @property {string} [className] - The className to apply to the row.
 * @property {string} [ariaLabel] - The aria-label to apply to the row.
 * @property {object} [style] - The style to apply to the row.
 * @property {Gap} [gap] - The gap size to apply to the row.
 * @property {ResponsiveWidth} [responsiveWidth] - The responsive width to apply to the row.
 */

/**
 * @deprecated Use `Stack` from `@mantine/core` instead (or `Flex` with `direction="column"` for custom alignment).
 * See: ui-components/readme-documentation/MIGRATION.md
 * @typedef {import('react').RefForwardingComponent} ReactForwardRef
 * @type {ReactForwardRef<HTMLDivElement, FlexRowProps>}
 */
export const FlexColumn = React.forwardRef(({ ariaLabel, children, className, style, gap, responsiveWidth }, ref) => (
  <div
    ref={ref}
    aria-label={ariaLabel}
    className={classnames(styles['flex-column'], responsiveStyles[responsiveWidth], styles[gap], className)}
    style={style}
  >
    {children}
  </div>
));
